<template>
    <div>
        <section class="form-steps">
            <div class="form-steps-inner">
                <div class="step" v-bind:class="{ 'complete' : step > 0}">
                    <div class="progress-bar">

                    </div>
                    <p>1 - About you</p>
                </div>
                <div class="step" v-bind:class="{ 'complete' : step > 1}">
                    <div class="progress-bar">

                    </div>
                    <p>2 - Your Home</p>
                </div>
                <div class="step" v-bind:class="{ 'complete' : step > 2}">
                    <div class="progress-bar">

                    </div>
                    <p>3 - Your Results</p>
                </div>
            </div>
        </section>

        <section class="form-container">
            <div class="form-inner">

                <div class="step-1" v-if="step == 1 && submitting == false">

                    <div class="step-intro">
                        <h1>Your grant application</h1>
                        <strong>Please answer all questions accurately and in full.</strong>
                        <p>If you qualify, we can arrange for a local, approved company to contact you to complete the installation of your new boiler. </p>
                        <h3>1 - About you</h3>
                    </div>

                    <div class="question">
                        <p>What is your relationship to the property which you are applying for?</p>
                        <strong class="click-help" @click="showHelp('home')"><span v-if="selectedHelp == 'home'">Hide</span><span v-else>Show</span> help</strong>
                        <div class="help-box" v-if="selectedHelp == 'home'">
                            <p>Please select the type of property you are applying for.</p>
                        </div>
                    </div>

                    <div class="error_alert" v-if="form.property_relationship == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="half-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_relationship','Home Owner')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_relationship == 'Home Owner'"></div>
                                    </div>
                                    <p>Home Owner</p>
                                </li>
                                <li @click="itemSelected('property_relationship','Private Tenant')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_relationship == 'Private Tenant'"></div>
                                    </div>
                                    <p>Private Tenant</p>
                                </li>
                                <li @click="itemSelected('property_relationship','Landlord')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_relationship == 'Landlord'"></div>
                                    </div>
                                    <p>Landlord</p>
                                </li>
                                <li @click="itemSelected('property_relationship','Council Tenant')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_relationship == 'Council Tenant'"></div>
                                    </div>
                                    <p>Council Tenant</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Gas present question start-->

                    <div v-if="form.property_relationship == 'Landlord' || form.property_relationship == 'Home Owner' || form.property_relationship == 'Private Tenant'">

                        <div class="question">
                            <p>Do you currently have gas present at the property?</p>
                        </div>

                        <div class="error_alert" v-if="form.gas_present == '' && formValidation == 1">
                            <p>Please select an option.</p>
                        </div>

                        <div class="half-block">
                            <div class="buttons">
                                <ul>
                                    <li @click="itemSelected('gas_present','Yes')">
                                        <div class="check-box">
                                            <div class="selected" v-if="form.gas_present == 'Yes'"></div>
                                        </div>
                                        <p>Yes</p>
                                    </li>
                                    <li @click="itemSelected('gas_present','No')">
                                        <div class="check-box">
                                            <div class="selected" v-if="form.gas_present == 'No'"></div>
                                        </div>
                                        <p>No</p>
                                    </li>
                                    <li @click="itemSelected('gas_present','Not Sure')">
                                        <div class="check-box">
                                            <div class="selected" v-if="form.gas_present == 'Not Sure'"></div>
                                        </div>
                                        <p>Not Sure</p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <!-- Gas present question end-->

                    <div class="question">
                        <p>How many adults live in the household?</p>
                    </div>

                    <div class="error_alert" v-if="form.property_adults == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="half-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_adults','1')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_adults == '1'"></div>
                                    </div>
                                    <p>1 adult</p>
                                </li>
                                <li @click="itemSelected('property_adults','2+')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_adults == '2+'"></div>
                                    </div>
                                    <p>2+ adults</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="question">
                        <p>How many children live in the household?</p>
                    </div>

                    <div class="error_alert" v-if="form.property_children == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="half-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_children','1')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_children == '1'"></div>
                                    </div>
                                    <p>1 child</p>
                                </li>
                                <li @click="itemSelected('property_children','2')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_children == '2'"></div>
                                    </div>
                                    <p>2 children</p>
                                </li>
                                <li @click="itemSelected('property_children','3')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_children == '3'"></div>
                                    </div>
                                    <p>3 children</p>
                                </li>
                                <li @click="itemSelected('property_children','4+')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_children == '4+'"></div>
                                    </div>
                                    <p>4+ children</p>
                                </li>
                                <li @click="itemSelected('property_children','0')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_children == '0'"></div>
                                    </div>
                                    <p>No children</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="question">
                        <p>Please select all benefits which <b>any occupants</b> received at the property</p>
                        <strong class="click-help" @click="showHelp('relationship')"><span v-if="selectedHelp == 'relationship'">Hide</span><span v-else>Show</span> help</strong>
                        <div class="help-box" v-if="selectedHelp == 'relationship'">
                            <p>If none apply then please select 'none of the above'.</p>
                        </div>
                    </div>

                    <div class="error_alert" v-if="form.benefits.length == 0 && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="full-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemMultiSelected('benefits','Pension Credit')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Pension Credit')"></div>
                                    </div>
                                    <p>Pension Credit</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','Child Tax Credits')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Child Tax Credits')"></div>
                                    </div>
                                    <p>Child Tax Credits</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','Working Tax Credits')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Working Tax Credits')"></div>
                                    </div>
                                    <p>Working Tax Credits</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','Universal Credit')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Universal Credit')"></div>
                                    </div>
                                    <p>Universal Credit</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','Income Support')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Income Support')"></div>
                                    </div>
                                    <p>Income Support</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','Income-Related Employment & Support Allowance (ESA)')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Income-Related Employment & Support Allowance (ESA)')"></div>
                                    </div>
                                    <p>Income-Related Employment & Support Allowance (ESA)</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','Income-Based Job Seekers Allowance (JSA)')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Income-Based Job Seekers Allowance (JSA)')"></div>
                                    </div>
                                    <p>Income-Based Job Seekers Allowance (JSA)</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','Pension Credit Guarantee')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Pension Credit Guarantee')"></div>
                                    </div>
                                    <p>Pension Credit Guarantee</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','Housing Benefit')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('Housing Benefit')"></div>
                                    </div>
                                    <p>Housing Benefit</p>
                                </li>
                                <li @click="itemMultiSelected('benefits','None of the above')">
                                    <div class="check-box">
                                        <div class="selected" v-if="this.form.benefits.includes('None of the above')"></div>
                                    </div>
                                    <p>None of the above</p>
                                </li>
                            </ul>
                            <div class="mt-5">
                                <a class="form-next blue-btn" @click="nextStep">Next step</a>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="step-1" v-if="step == 2 && submitting == 0">

                    <div class="question">
                        <p>What type of property are you applying for?</p>
                    </div>

                    <div class="error_alert" v-if="form.property_type == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="full-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_type','Detached')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_type == 'Detached'"></div>
                                    </div>
                                    <p>Detached</p>
                                </li>
                                <li @click="itemSelected('property_type','Semi Detached')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_type == 'Semi Detached'"></div>
                                    </div>
                                    <p>Semi Detached</p>
                                </li>
                                <li @click="itemSelected('property_type','Terraced')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_type == 'Terraced'"></div>
                                    </div>
                                    <p>Terraced</p>
                                </li>
                                <li @click="itemSelected('property_type','Flat')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_type == 'Flat'"></div>
                                    </div>
                                    <p>Flat</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="question">
                        <p>How many bedrooms does the property have?</p>
                    </div>

                    <div class="error_alert" v-if="form.property_bedrooms == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="half-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_bedrooms','1')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_bedrooms == '1'"></div>
                                    </div>
                                    <p>1</p>
                                </li>
                                <li @click="itemSelected('property_bedrooms','2')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_bedrooms == '2'"></div>
                                    </div>
                                    <p>2</p>
                                </li>
                                <li @click="itemSelected('property_bedrooms','3')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_bedrooms == '3'"></div>
                                    </div>
                                    <p>3</p>
                                </li>
                                <li @click="itemSelected('property_bedrooms','4')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_bedrooms == '4'"></div>
                                    </div>
                                    <p>4</p>
                                </li>
                                <li @click="itemSelected('property_bedrooms','5')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_bedrooms == '5'"></div>
                                    </div>
                                    <p>5</p>
                                </li>
                                <li @click="itemSelected('property_bedrooms','6+')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_bedrooms == '6+'"></div>
                                    </div>
                                    <p>6+</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="question">
                        <p>What's the main fuel type that heats the property?</p>
                        <strong class="click-help" @click="showHelp('fuel')"><span v-if="selectedHelp == 'fuel'">Hide</span><span v-else>Show</span> help</strong>
                        <div class="help-box" v-if="selectedHelp == 'fuel'">
                            <p>Most homes with a traditional boiler will be on a mains gas supply.</p>
                        </div>
                    </div>

                    <div class="error_alert" v-if="form.property_fuel == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="full-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_fuel','Mains gas')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_fuel == 'Mains gas'"></div>
                                    </div>
                                    <p>Mains gas</p>
                                </li>
                                <li @click="itemSelected('property_fuel','LPG or bottled gas')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_fuel == 'LPG or bottled gas'"></div>
                                    </div>
                                    <p>LPG or bottled gas</p>
                                </li>
                                <li @click="itemSelected('property_fuel','Oil')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_fuel == 'Oil'"></div>
                                    </div>
                                    <p>Oil</p>
                                </li>
                                <li @click="itemSelected('property_fuel','Electric')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_fuel == 'Electric'"></div>
                                    </div>
                                    <p>Electric</p>
                                </li>
                                <li @click="itemSelected('property_fuel','Coal')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_fuel == 'Coal'"></div>
                                    </div>
                                    <p>Coal</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="question">
                        <p>What type of boiler does the property currently have?</p>
                        <strong class="click-help" @click="showHelp('property')"><span v-if="selectedHelp == 'property'">Hide</span><span v-else>Show</span> help</strong>
                        <div class="help-box" v-if="selectedHelp == 'property'">
                            <p>Most boilers in the UK are wall mounted, if different please select.</p>
                        </div>
                    </div>

                    <div class="error_alert" v-if="form.property_boiler_type == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="half-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_boiler_type','No Boiler')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_type == 'No Boiler'"></div>
                                    </div>
                                    <p>No Boiler</p>
                                </li>
                                <li @click="itemSelected('property_boiler_type','Combi Boiler')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_type == 'Combi Boiler'"></div>
                                    </div>
                                    <p>Combi Boiler</p>
                                </li>
                                <li @click="itemSelected('property_boiler_type','Regular Boiler')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_type == 'Regular Boiler'"></div>
                                    </div>
                                    <p>Regular Boiler</p>
                                </li>
                                <li @click="itemSelected('property_boiler_type','System Boiler')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_type == 'System Boiler'"></div>
                                    </div>
                                    <p>System Boiler</p>
                                </li>
                                <li @click="itemSelected('property_boiler_type','Back Boiler')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_type == 'Back Boiler'"></div>
                                    </div>
                                    <p>Back Boiler (Behind Fire)</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="question">
                        <p>Where does your boiler flue exit the property?</p>
                        <strong class="click-help" @click="showHelp('property_boiler_flue')"><span v-if="selectedHelp == 'property_boiler_flue'">Hide</span><span v-else>Show</span> help</strong>
                        <div class="help-box" v-if="selectedHelp == 'property_boiler_flue'">
                            <p>A boiler flue is a pipe that carries exhaust gases produced by a boiler outside the home and releases it into the atmosphere, normally found on an external wall or exiting the roof.</p>
                        </div>
                    </div>

                    <div class="error_alert" v-if="form.property_boiler_flue == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="half-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_boiler_flue','External Wall')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_flue == 'External Wall'"></div>
                                    </div>
                                    <p>External Wall</p>
                                </li>
                                <li @click="itemSelected('property_boiler_flue','Roof Sloped')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_flue == 'Roof Sloped'"></div>
                                    </div>
                                    <p>Roof (Sloped)</p>
                                </li>
                                <li @click="itemSelected('property_boiler_flue','Roof Flat')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_flue == 'Roof Flat'"></div>
                                    </div>
                                    <p>Roof (Flat)</p>
                                </li>
                                <li @click="itemSelected('property_boiler_flue','Other')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_flue == 'Other'"></div>
                                    </div>
                                    <p>Other</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="question">
                        <p>Approximately how old is the current boiler?</p>
                    </div>

                    <div class="error_alert" v-if="form.property_boiler_age == '' && formValidation == 1">
                        <p>Please select an option.</p>
                    </div>

                    <div class="half-block">
                        <div class="buttons">
                            <ul>
                                <li @click="itemSelected('property_boiler_age','18+ Years Old')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_age == '18+ Years Old'"></div>
                                    </div>
                                    <p>18+ Years Old</p>
                                </li>
                                <li @click="itemSelected('property_boiler_age','10+ Years Old')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_age == '10+ Years Old'"></div>
                                    </div>
                                    <p>10+ Years Old</p>
                                </li>
                                <li @click="itemSelected('property_boiler_age','5-9 Years Old')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_age == '5-9 Years Old'"></div>
                                    </div>
                                    <p>5-9 Years Old</p>
                                </li>
                                <li @click="itemSelected('property_boiler_age','Less Than 5 years Old')">
                                    <div class="check-box">
                                        <div class="selected" v-if="form.property_boiler_age == 'Less Than 5 years Old'"></div>
                                    </div>
                                    <p>Less Than 5 years Old</p>
                                </li>
                            </ul>
                            <div class="flex mt-5">
                                <a class="form-next blue-btn" @click="nextStepTwo()">Next step</a>
                                <a class="form-back" @click="backStep()">Back</a>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="step-3" v-if="step == 3 && submitting == false">

                    <p style="font-size: 18px;">Complete the last step before to see if you qualify for Government funding for a new boiler.</p>

                    <hr>

                    <form>

                        <div class="row">

                            <div class="form-group col-12 col-md-3">
                                <label for="title">Title</label>
                                <select class="form-control" name="title" v-model="enquiryForm.title">
                                    <option selected disabled value="default">Select title</option>
                                    <option value="Mr">Mr</option>
                                    <option value="Mrs">Mrs</option>
                                    <option value="Miss">Miss</option>
                                    <option value="Ms">Ms</option>
                                </select>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-12 col-md-6">
                                <label for="first_name">First name</label>
                                <input type="text" class="form-control" id="first_name" v-model="enquiryForm.first_name" aria-describedby="first_name">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="last_name">Last name</label>
                                <input type="text" class="form-control" id="last_name" v-model="enquiryForm.last_name" aria-describedby="last_name">
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-12 col-md-6">
                                <label for="phone_number">Phone number</label>
                                <input type="number" class="form-control" id="phone_number" v-model="enquiryForm.phone_number" aria-describedby="phone_number">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="email">Email address</label>
                                <input type="email" class="form-control" id="email" v-model="enquiryForm.email" aria-describedby="email">
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-12 col-md-6">
                                <label for="house_number">House number</label>
                                <input type="text" class="form-control" id="house_number" v-model="enquiryForm.house_number" aria-describedby="house_number">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="postcode">Postcode</label>
                                <input type="text" class="form-control" id="postcode" v-model="enquiryForm.postcode" aria-describedby="postcode">
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="terms" v-model="enquiryForm.terms" value="accept">
                                <label class="form-check-label" for="terms">I accept the <a href="/privacy-policy" target="_blank">privacy policy</a></label>
                            </div>

                        </div>

                        <div class="error_alert" v-if="formValidation == 1">
                            <p>Please enter all the fields above.</p>
                        </div>

                        <div class="row">

                            <div class="form-group col-12">

                                <button type="submit" :disabled="submitting == true" class="form-next blue-btn" @click.prevent="submitEnquiryForm()">
                                    <span v-if="submitting == true">Submitting..</span>
                                    <span v-else>Get Results</span>
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

                <div class="step-3" v-if="step == 4 && submitting == false">

                    <h2>Thank you</h2>
                    <p>Your details have been submitted to us, please allow 24-48 hours to process your application and call you to complete the full assessment.</p>

                </div>

                <div v-if="submitting == 1" class="text-center">

                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <h3 class="mt-4">Loading...</h3>

                </div>

            </div>
        </section>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                selectedHelp: '',
                step: 1,
                submitting: 0,
                formValidation: 0,
                form: {
                    property_relationship: '',
                    gas_present: '',
                    property_adults: '',
                    property_children: '',
                    benefits: [],
                    property_type: '',
                    property_bedrooms: '',
                    property_fuel: '',
                    property_boiler_type: '',
                    property_boiler_age: '',
                    property_boiler_flue: '',
                },
                enquiryForm: {
                    title: 'default',
                    first_name: '',
                    last_name: '',
                    phone_number: '',
                    email: '',
                    house_number: '',
                    postcode: '',
                    terms: ''
                }
            };
        },

        mounted: function() {

        },

        methods: {

            submitEnquiryForm: function() {

                this.submitting = true;
                window.scrollTo(0, 0);

                var validation = this.formValidationChecker(3);

                if (validation == true) {

                    // post axios
                    axios.post('/api/enquiry',{
                        form: this.form,
                        enquiry: this.enquiryForm
                    })
                    .then(response => {

                        if (response.data.success == 1) {

                            window.fbq('track', 'Lead');

                            setTimeout(() => {
                                // success show form
                                window.location.href = '/thanks';
                            }, 1000)


                        } else {

                            // delay response
                            this.delayLoading(3000);

                        }

                        return response;

                    }).catch(error => {
                        console.log(error);
                    });

                } else {
                    this.submitting = false;
                }

            },

            delayLoading: function(time) {

                this.submitting = true;

                setTimeout(function() {
                    window.location.href = '/sorry';
                }, time)

            },

            backStep: function() {

                this.submitting = true;
                scroll(0,0)
                this.step--

                setTimeout(() => {
                    this.submitting = false
                }, 500)

            },

            nextStep: function() {

                // form validation
                var validation = this.formValidationChecker(1);

                if (validation == true) {

                    this.submitting = true;
                    scroll(0,0)
                    this.step++;

                    setTimeout(() => {
                        this.submitting = false
                    }, 500)

                } else {

                    scroll(0,0)

                }

            },

            nextStepTwo: function() {

                // form validation
                var validation = this.formValidationChecker(2);

                if (validation == true) {

                    this.submitting = true;
                    scroll(0,0)
                    this.step++;

                    setTimeout(() => {
                        this.submitting = false
                    }, 500)

                } else {

                    scroll(0,0)

                }

            },

            formValidationChecker: function(step) {

                this.formValidation = 0;

                // add validation
                switch (step) {
                    case 1:

                        if (this.form.property_relationship == '') {
                            this.formValidation = 1;
                        }

                        if (this.form.property_relationship == 'Landlord' || this.form.property_relationship == 'Home Owner' || this.form.property_relationship == 'Private Tenant') {
                            if(this.form.gas_present == ''){
                                this.formValidation = 1;
                            }
                        }

                        if (this.form.property_adults == '') {
                            this.formValidation = 1;
                        }

                        if (this.form.property_children == '') {
                            this.formValidation = 1;
                        }

                        if (this.form.benefits.length == 0) {
                            this.formValidation = 1;
                        }

                        break;

                    case 2:

                        if (this.form.property_type == '') {
                            this.formValidation = 1;
                        }

                        if (this.form.property_bedrooms == '') {
                            this.formValidation = 1;
                        }

                        if (this.form.property_fuel == '') {
                            this.formValidation = 1;
                        }

                        if (this.form.property_boiler_type == '') {
                            this.formValidation = 1;
                        }

                        if (this.form.property_boiler_age == '') {
                            this.formValidation = 1;
                        }

                        if (this.form.property_boiler_flue == '') {
                            this.formValidation = 1;
                        }

                        break;

                    case 3:

                        if (this.enquiryForm.title == 'default') {
                            this.formValidation = 1;
                        }

                        if (this.enquiryForm.first_name == '') {
                            this.formValidation = 1;
                        }

                        if (this.enquiryForm.last_name == '') {
                            this.formValidation = 1;
                        }

                        if (this.enquiryForm.phone_number == '') {
                            this.formValidation = 1;
                        }

                        if (this.enquiryForm.house_number == '') {
                            this.formValidation = 1;
                        }

                        if (this.enquiryForm.email == '') {
                            this.formValidation = 1;
                        }

                        if (this.enquiryForm.postcode == '') {
                            this.formValidation = 1;
                        }

                        if (this.enquiryForm.terms == '') {
                            this.formValidation = 1;
                        }

                        break;

                }

                if (this.formValidation == 0) {

                    return true;

                }

            },

            showHelp: function(item) {

                if (this.selectedHelp == item) {
                    this.selectedHelp = ''
                } else {
                    this.selectedHelp = item;
                }

            },

            itemSelected: function(item,value) {

                this.form[item] = value;

            },

            itemMultiSelected: function(item,value) {

                var foundIndex = this.form[item].indexOf(value)

                if (foundIndex !== -1) {
                    this.form[item].splice(foundIndex, 1);
                } else {
                    this.form[item].push(value);
                }

            }

        },

    };
</script>
